module.exports = __webpack_public_path__ + "img/favicon_178.008f1c5b.png";